// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {contractUpdate, updateStatusByContractList} from "../../../Contract/ContractClient";
import {changeWorkQueue} from "../../workQueueSlice";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";


// main function
export default function RejectContract({ onMenuClose, rowContractData, selectorContractList }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);

    //
    // const handleReject = () => {
    //     onMenuClose();
    //     updateStatusByContractList(selectorContractList, 'Rejected')
    //         .then(() => {
    //             dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
    //         });
    // };

    const handleReject = () => {
        onMenuClose();
        contractUpdate(contractArray, [], [],'Update Status',
            '2036', null, currentUserName, true)
            .then(() => {
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
            });
    };


    return (

        <Box>
            {(rowContractData.contractLevel === "Guild" &&
                    rowContractData.contractStatus !== "Rejected" &&
                    rowContractData.contractStatus !== "Approved")
                &&
                <MenuItem onClick={handleReject}>
                    <ListItemIcon>
                        <ThumbDownIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Reject</ListItemText>
                </MenuItem>}
        </Box>

    )

}
